import { ChangeDetectorRef, Directive, EventEmitter, Input, OnDestroy, Output, ViewRef } from '@angular/core';
import { BundleOptionSelection, IBundleSelectionOptionsData } from '@df/catalog/product/bundle-option-selection';
import { BundleSelection } from '@df/catalog/product/bundle-selection';
import { IProductDataBundleOption, Product } from '@df/catalog/product/product';
import { OnChange } from '@df/ng/on-change';
import { TimeoutService } from '@df/ng/timeout.service';
import { Nexus } from '@tomandco/nexus-api-types';
import each from 'lodash-es/each';
import { Subscription } from 'rxjs';

export interface IBundleEvent {
    selection: BundleSelection;
    vm: ProductBundleOptionsComponentDef;
}

@Directive()
export class ProductBundleOptionsComponentDef implements OnDestroy {
    data: any = {};

    /**
     * Selection subscriptin
     */
    protected selectionSubscription?: Subscription;

    /**
     * Bundle product
     *
     *
     * IMPORTANT: we do NOT support model changes - if you want to change this be careful with storage
     *
     * @type {Product}
     */
    @Input({
        required: true
    })
    product?: Product;

    /**
     * Buy request
     * Should be set if you want bundle options injected into it
     */
    @Input()
    buyRequest?: Omit<Nexus.Lib.Basket.BasketRequestData, 'id'>;

    /**
     * Selction object
     * @see BundleSelection
     * @type {BundleSelection}
     */
    @Input()
    @OnChange(function (this: ProductBundleOptionsComponentDef) {
        if (this.selectionSubscription) {
            this.selectionSubscription.unsubscribe();
        }

        if (this.selection) {
            // subscribe to selection changes
            this.selectionSubscription = this.selection.subscribe(() => {
                // save chanages to hash
                // if (this.storageHandle) {
                //     this.storageHandle.save();
                // }

                // if buy request is present patch its data
                if (this.buyRequest) {
                    this.buyRequest.bundle_options = this.selection ? this.selection.selection : undefined;
                }

                // trigger callback
                if (this.selection) {
                    this.selectionChange.emit({ selection: this.selection, vm: this });
                }
            });

            // trigger on change things
            this.selection.next();
        }
    })
    selection?: BundleSelection;

    /**
     * Storage name
     * @see storageName binding in component
     * @type {string}
     */
    @Input()
    storage: undefined | string;

    /**
     * Storage handle
     * @see storage.ts
     * @type {IStorageHandle}
     */
    // storageHandle: IStorageHandle;

    /**
     * On change callback
     */
    @Output()
    selectionChange = new EventEmitter<IBundleEvent>();

    /**
     * class constructor
     */

    constructor(
        protected _ref: ChangeDetectorRef,
        protected timeoutService: TimeoutService
    ) {}

    /**
     * Called on component initiation
     * If storage param is set then it will bind itself
     */
    ngOnInit(): void {
        if (this.product && this.product.isBundle) {
            // let storage = this.storage ? this.storageService.getStorage(this.storage) : false;
            // if (storage) {
            //     this.storageHandle = storage.bind(
            //         'bundle',
            //         data => this.setData(data),
            //         () => (this.selection ? this.selection.editableSelection : undefined)
            //     );
            // }

            if (!this.selection) {
                this.selection = this.product.createBundleSelectionObject(this.buyRequest ? this.buyRequest.bundle_options : undefined);
            }

            // load data from hash if storage is set
            // if (storage) {
            //     this.storageHandle.next();
            // }

            // subscribe to selection changes
            this.selectionSubscription = this.selection.subscribe(() => {
                // save chanages to hash
                // if (this.storageHandle) {
                //     this.storageHandle.save();
                // }

                // if buy request is present patch its data
                if (this.buyRequest) {
                    this.buyRequest.bundle_options = this.selection ? this.selection.selection : undefined;
                }

                // trigger callback
                if (this.selection) {
                    this.selectionChange.emit({ selection: this.selection, vm: this });
                }

                this.detectChanges();
            });

            // trigger on change things
            this.selection.next();
        } else {
            this.selection = undefined;
        }
    }

    detectChanges() {
        this.timeoutService.async(() => {
            if (!(<ViewRef>this._ref).destroyed) {
                this._ref.detectChanges();
            }
        });
    }

    /**
     * Cleanup
     * unsubscribes
     */
    ngOnDestroy(): void {
        if (this.selectionSubscription) {
            this.selectionSubscription.unsubscribe();
        }
    }

    get bundleOptions(): BundleOptionSelection[] | undefined {
        return this.selection ? this.selection.editableOptions.filter(i => !!i.children.length) : undefined;
    }

    /**
     * Tracking function for options
     */
    optionTrackFn(index: number, option: IProductDataBundleOption): number {
        return option.id;
    }

    //////////////////////////////////////////////////
    //
    // SERIALIZATION
    //
    //////////////////////////////////////////////////

    setData(source: IBundleSelectionOptionsData): void {
        each(source, (option, optionId) => {
            if (this.selection && this.selection.options && this.selection.options[optionId]) {
                this.data[optionId] = this.selection.options[optionId].children.find(
                    value => value.selection_id === parseInt(Object.keys(option)[0], 10)
                );
            }
        });

        return source && this.selection && this.selection.setData(source);
    }
}
